export function getAuthToken(): string | null {
  try {
    const raw = localStorage.getItem('token');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.tokens?.access?.token ?? null;
  } catch {
    localStorage.removeItem('token');
    return null;
  }
}
